module.exports = __webpack_public_path__ + "static/media/black-panther-a-nation-under-our-feet-book2.af488e47.jpg";